import { Component } from '@angular/core';
import { AppSettings } from './app.settings';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';

enum Policy {
  Privacy = 'privacy_policy',
  Terms = 'terms_and_conditions',
  Refund = 'refund_policy'
}
const POLICIES = {
  [Policy.Privacy]: 'Privacy Policy',
  [Policy.Terms]: 'Terms and Conditions',
  [Policy.Refund]: 'Refund Policy'
};

@Component({
  selector: 'app-footer',
  template: `
    <section class="container footer">
      <div class="row">
        <div class="col-12">
          <div class="row" *ngIf="showPolicies">
            <a
              class="col-4 text-right"
              target="_blank"
              (click)="open(content, Policy.Privacy)"
              >Privacy Policy</a
            >
            <a
              class="col-4 text-center"
              target="_blank"
              (click)="open(content, Policy.Terms)"
              >Terms & Conditions</a
            >
            <a
              class="col-4 text-left"
              target="_blank"
              (click)="open(content, Policy.Refund)"
              >Refund Policy</a
            >
          </div>
        </div>
        <div class="col-12">
          <hr />
        </div>
        <div class="col-12 text-center">
          <img
            src="https://s3-us-west-2.amazonaws.com/idonate-embed/images/poweredby.svg"
            alt="Powered by iDonate"
            id="poweredby"
            class="d-block mx-auto center-block"
          />
          <a
            href="https://idonate.com/privacy-policy/?utm_source=Single Page Embed"
            target="_blank"
            aria-label="Privacy Policy"
            title="Privacy Policy"
            class="d-block mx-auto center-block"
            >Privacy Policy</a
          >
        </div>
      </div>
    </section>
    <ng-template #content let-c="close" let-d="dismiss">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="d('Cross click')"
        >
          <span aria-hidden="true" aria-label="Close modal">&times;</span>
        </button>
        <h2>{{ policyName }}</h2>
      </div>
      <div class="modal-body" [innerHtml]="policy"></div>
    </ng-template>
  `
})
export class FooterComponent {
  Policy = Policy;
  showPolicies = false;
  policyName: string;
  policy: SafeHtml = '';
  constructor(
    private settings: AppSettings,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer
  ) {
    if (this.settings.getValue('properties').show_standard_policies) {
      this.showPolicies = true;
    }
  }
  open(content, policy: string) {
    this.policyName = POLICIES[policy];
    const attributes = this.settings.getValue('organization').attributes;
    this.policy = this.sanitizer.bypassSecurityTrustHtml(
      attributes[`legal.${policy}`] || ''
    );
    this.modalService.open(content);
  }
}
